module.exports = "<div class=\"header-menu-time\">\n  {{getTime() | date:'HH:mm'}}\n</div>\n"